import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3976_68521)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M4.66699 6.44597C4.66699 5.97441 4.85432 5.52217 5.18776 5.18873C5.5212 4.85529 5.97344 4.66797 6.44499 4.66797H12.2223C12.4558 4.66797 12.687 4.71396 12.9027 4.80331C13.1185 4.89266 13.3145 5.02363 13.4796 5.18873C13.6447 5.35384 13.7756 5.54984 13.865 5.76556C13.9543 5.98127 14.0003 6.21248 14.0003 6.44597V12.2233C14.0003 12.4568 13.9543 12.688 13.865 12.9037C13.7756 13.1194 13.6447 13.3154 13.4796 13.4805C13.3145 13.6456 13.1185 13.7766 12.9027 13.866C12.687 13.9553 12.4558 14.0013 12.2223 14.0013H6.44499C6.2115 14.0013 5.9803 13.9553 5.76458 13.866C5.54886 13.7766 5.35286 13.6456 5.18776 13.4805C5.02265 13.3154 4.89169 13.1194 4.80233 12.9037C4.71298 12.688 4.66699 12.4568 4.66699 12.2233V6.44597Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M2.67467 11.158C2.47023 11.0415 2.30018 10.873 2.18172 10.6697C2.06325 10.4663 2.00057 10.2353 2 10V3.33333C2 2.6 2.6 2 3.33333 2H10C10.5 2 10.772 2.25667 11 2.66667",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3976_68521",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgCopy;
